/*
 * SR Cart Upsell — buy-together suggestions for Cart page + Cart drawer.
 */
(function () {
  'use strict';
  if (window.__srUpsellInit) return;
  window.__srUpsellInit = true;

  var CFG = null;
  try {
    var cfgEl = document.getElementById('sr-upsell-config');
    if (cfgEl) CFG = JSON.parse(cfgEl.textContent);
  } catch (e) {}
  if (!CFG || !CFG.enabled || !CFG.pairs || !CFG.pairs.length) return;

  var MAX = CFG.maxSuggest || 8;

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function formatMoney(cents) {
    return Math.round(cents / 100).toLocaleString('vi-VN') + '\u0111';
  }

  function cartProductIds() {
    var map = {};
    try {
      var state = window.scaCart && window.scaCart.getState ? window.scaCart.getState() : null;
      var items = state && state.cart && state.cart.items ? state.cart.items : [];
      for (var i = 0; i < items.length; i++) map[items[i].product_id] = true;
    } catch (e) {}
    return map;
  }

  function sideHas(side, inCart) {
    for (var i = 0; i < side.ids.length; i++) if (inCart[side.ids[i]]) return true;
    return false;
  }

  function buildBlocks() {
    var inCart = cartProductIds();
    var out = [];
    for (var i = 0; i < CFG.pairs.length; i++) {
      var pair = CFG.pairs[i];
      var hasA = sideHas(pair.a, inCart);
      var hasB = sideHas(pair.b, inCart);
      var target = null;
      if (hasA && !hasB) target = pair.b;
      else if (hasB && !hasA) target = pair.a;
      if (!target) continue;
      var items = [];
      for (var j = 0; j < target.items.length && items.length < MAX; j++) {
        var p = target.items[j];
        if (p.available && !inCart[p.id]) items.push(p);
      }
      if (items.length) out.push({
        badge: pair.badge,
        discountAmount: pair.discountAmount || 0,
        partner: target.name,
        items: items
      });
    }
    return out;
  }

  function headingFor(block) {
    var h = CFG.heading || '{partner}';
    return h.replace(/\{partner\}/g, block.partner).replace(/\{badge\}/g, block.badge);
  }

  function cardHTML(p, block) {
    var badge = block.badge;
    var discountAmt = block.discountAmount || 0;
    var multi = p.variants > 1;

    // priceRaw từ Shopify = cents (VD: 32900000 = 329.000đ)
    // discountAmount nhập VND thực (VD: 20000) → nhân 100 để ra cents
    var discountCents = discountAmt * 100;
    var discountedRaw = p.priceRaw - discountCents;
    if (discountedRaw < 0) discountedRaw = 0;

    var showDiscounted = discountAmt > 0;
    var displayPriceStr = showDiscounted ? formatMoney(discountedRaw) : p.priceStr;
    var compareStr = (CFG.showCompare && showDiscounted)
      ? p.priceStr
      : (CFG.showCompare && p.onSale ? p.compareStr : null);

    var priceHTML = '<div class="price price--sale">' +
      '<span class="price__number price__number--sale">' + esc(displayPriceStr) + '</span>' +
      (compareStr ? ' <span class="price__compare">' + esc(compareStr) + '</span>' : '') +
      '</div>';

    var img = p.img
      ? '<img class="product-card__img" src="' + esc(p.img) + '" alt="' + esc(p.title) + '" loading="lazy" width="120" height="160">'
      : '';

    return (
      '<div class="product-card product-card--mini js-product js-product-card" data-product-id="' + p.id + '">' +
        '<a product-card-link class="product-card__link" href="' + esc(p.url) + '">' +
          '<span class="visually-hidden">' + esc(p.title) + '</span>' +
        '</a>' +
        '<div class="product-card__top">' +
          '<div class="o-ratio o-ratio--natural" style="padding-bottom:149.925%;">' +
            '<div class="o-ratio__content">' +
              '<a product-card-link href="' + esc(p.url) + '" tabindex="-1">' +
                '<div class="product-card__media">' + img + (badge ? '<span class="sru-card__badge">' + esc(badge) + '</span>' : '') + '</div>' +
              '</a>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<div class="product-card__details">' +
          '<h3 class="product-card__title">' +
            '<product-card-title>' + esc(p.title) + '</product-card-title>' +
          '</h3>' +
          '<product-card-price class="product-card__price">' + priceHTML + '</product-card-price>' +
          '<product-card-button class="product-card-btn">' +
            (multi
              ? '<button type="button" class="link link--underline" data-trigger-quick-shop>Xem nhanh</button>'
              : '<button type="button" class="link link--underline sru-card__add-btn" data-vid="' + esc(p.vid) + '" data-url="' + esc(p.url) + '">' + esc(CFG.btnText || 'Thêm') + '</button>'
            ) +
          '</product-card-button>' +
        '</div>' +
        '<button type="button" class="quick-shop__trigger sru-quick-buy-btn" data-trigger-quick-shop aria-hidden="true" tabindex="-1">' +
          '<span class="icon icon--theme icon--quickbuy">' +
            '<svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">' +
              '<path d="M27.5 43.5H5V14.4048H43V28.2611M34 14.1984V13.8105C34 8.66844 29.702 4.5 24.4 4.5H23.6C18.2981 4.5 14 8.66844 14 13.8105V14.1984M35 28.746V35.5349M35 35.5349V42.3238M35 35.5349H28M35 35.5349L42 35.5349" vector-effect="non-scaling-stroke"></path>' +
            '</svg>' +
          '</span>' +
        '</button>' +
        '<quick-shop id="quick-shop-' + p.id + '" placeholder' +
          ' class="modal modal--right is-inside-modal quick-shop--drawer-' + (CFG.colorDrawerStyle || 'dark') + ' quick-shop--media-ratio-natural"' +
          ' image-container-ratio="natural" image-sizes="120px"' +
          ' data-product-url="' + esc(p.url) + '"' +
          ' aria-labelledby="quick-shop-' + p.id + '-title" aria-hidden="true">' +
          '<div class="modal__overlay" data-a11y-dialog-hide></div>' +
          '<div class="modal__wrapper" role="document">' +
            '<div class="quick-shop__wrapper"></div>' +
          '</div>' +
        '</quick-shop>' +
      '</div>'
    );
  }

  function blockHTML(block) {
    var cards = block.items.map(function (p) { return cardHTML(p, block); }).join('');
    return (
      '<div class="sr-upsell" data-sr-upsell>' +
        '<div class="sr-upsell__head">' +
          '<span class="sr-upsell__title">' + esc(headingFor(block)) + '</span>' +
          '<div class="sr-upsell__nav">' +
            '<button type="button" class="sr-upsell__btn sr-upsell__btn--prev" aria-label="Previous slide">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M15 19l-7-7 7-7" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
            '</button>' +
            '<button type="button" class="sr-upsell__btn sr-upsell__btn--next" aria-label="Next slide">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M9 5l7 7-7 7" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
            '</button>' +
          '</div>' +
        '</div>' +
        '<div class="sr-upsell__scroll"><div class="sr-upsell__track">' + cards + '</div></div>' +
      '</div>'
    );
  }

  // --- click handler ---
  document.addEventListener('click', function (e) {
    var prevBtn = e.target.closest ? e.target.closest('.sr-upsell__btn--prev') : null;
    if (prevBtn) {
      e.preventDefault();
      var sc = prevBtn.closest('.sr-upsell');
      if (sc) { var el = sc.querySelector('.sr-upsell__scroll'); if (el) el.scrollBy({ left: -250, behavior: 'smooth' }); }
      return;
    }
    var nextBtn = e.target.closest ? e.target.closest('.sr-upsell__btn--next') : null;
    if (nextBtn) {
      e.preventDefault();
      var sc = nextBtn.closest('.sr-upsell');
      if (sc) { var el = sc.querySelector('.sr-upsell__scroll'); if (el) el.scrollBy({ left: 250, behavior: 'smooth' }); }
      return;
    }
    var addBtn = e.target.closest ? e.target.closest('.sru-card__add-btn') : null;
    if (addBtn) {
      e.preventDefault();
      var vid = parseInt(addBtn.getAttribute('data-vid'), 10);
      if (!vid) { window.location.href = addBtn.getAttribute('data-url'); return; }
      if (!(window.scaCart && window.scaCart.add)) { window.location.href = addBtn.getAttribute('data-url'); return; }
      addBtn.classList.add('is-loading');
      addBtn.disabled = true;
      Promise.resolve(window.scaCart.add({ id: vid, quantity: 1 }))
        .catch(function () {})
        .then(function () { schedule(); });
      return;
    }
    var qsBtn = e.target.closest ? e.target.closest('[data-trigger-quick-shop]') : null;
    if (qsBtn) {
      e.preventDefault();
      var card = qsBtn.closest('.product-card--mini');
      if (card) {
        var productId = card.getAttribute('data-product-id');

        // Tìm theo ID — hoạt động dù qs đã teleport ra body
        var qs = document.getElementById('quick-shop-' + productId);
        if (qs) {
          if (!qs.classList.contains('sru-teleported')) {
            qs.classList.add('sru-teleported');

            // Đóng/reset trước khi move để tránh mở 2 lớp
            if (typeof qs.close === 'function') qs.close();

            document.body.appendChild(qs);
          }
          if (typeof qs.open === 'function') qs.open();
        }
      }
    }
  });

  // --- inject / refresh ---
  var _timer = null;
  var _isLoading = false;

  function inject() {
    if (_isLoading) return;
    var blocks = buildBlocks();
    var containers = document.querySelectorAll('.cart__contents');
    for (var c = 0; c < containers.length; c++) {
      var box = containers[c];
      var old = box.querySelectorAll('[data-sr-upsell]');
      for (var o = 0; o < old.length; o++) old[o].remove();
      if (!blocks.length) continue;
      var holder = document.createElement('div');
      holder.innerHTML = blocks.map(blockHTML).join('');
      var nodes = Array.prototype.slice.call(holder.children);
      if (CFG.position === 'top') {
        for (var t = nodes.length - 1; t >= 0; t--) box.insertBefore(nodes[t], box.firstChild);
      } else {
        var anchor = box.querySelector('cart-items');
        var ref = anchor ? anchor.nextSibling : null;
        for (var n = 0; n < nodes.length; n++) {
          if (anchor && ref) box.insertBefore(nodes[n], ref);
          else if (anchor) box.appendChild(nodes[n]);
          else box.appendChild(nodes[n]);
        }
      }
    }
  }

  // Debounce duy nhất — mọi trigger đều đi qua đây, không gọi inject() trực tiếp
  function schedule() {
    if (_timer) clearTimeout(_timer);
    _timer = setTimeout(function () { _timer = null; inject(); }, 120);
  }

  function attachStore(tries) {
    if (window.scaCart && window.scaCart.subscribe) {
      try { window.scaCart.subscribe(schedule); } catch (e) {}
      return;
    }
    if (tries > 0) setTimeout(function () { attachStore(tries - 1); }, 300);
  }

  function start() {
    inject();
    attachStore(20);
    document.addEventListener('on:cart:loaded', function () {
      _isLoading = false;
      schedule();
    });
    document.addEventListener('on:cart:loading', function () {
      _isLoading = true;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
